import { DispositionRecommendedAction, ProtocolListAssignment } from '@app/advisor-shared';
import { ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { filterInstances, sortArray } from '@nu-art/ts-common';
import { ProtocolData } from './ProtocolData/ProtocolData.js';
import { ProtocolStatus_AwaitingDispo } from './ProtocolData/types.js';
export const getDispoOptions = (type) => {
    const protocols = filterInstances(ModuleFE_RuntimeProtocol.cache.all()
        .map(p => ProtocolData.createNew(p._id)))
        .filter(p => [ProtocolListAssignment.CONSIDER_NOW,
        ProtocolListAssignment.ENDED].includes(p.getListAssignment()) && p.pathway.type !== 'chief-complaint' && p.pathway.type !== 'order-set');
    ProtocolData.sort(protocols);
    if (type === DispositionRecommendedAction.ADMIT || type === DispositionRecommendedAction.DISCHARGE)
        sortArray(protocols, p => p.getStatus() === ProtocolStatus_AwaitingDispo && !!p.getAwaitingOrders().find(order => order.resourceType === type), true);
    return [...protocols.map(p => ({ label: p.getLabel(), data: p })), { label: 'Other Working Diagnosis' }];
};
//# sourceMappingURL=get-dispo-options.js.map